import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { Box, Checkbox, Modal, Tooltip } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import CommonDynamicTablePaginationNew from "../../../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import DatePickerFieldNew from "../../../../common/components/FormFields/DatePickerFieldNew";
import InputField from "../../../../common/components/FormFields/InputField";
import RadioField from "../../../../common/components/FormFields/RadioField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import CommonPrintModal from "../../../../common/components/printModal/CommonPrintModal";
import {
  cancelVerifyPurchaseOrder,
  fetchAllPurchaseOrderItemDetailList,
  fetchAllPurchaseOrderList,
  fetchPrintPOForm,
  poItemDetailsSearch,
  searchPONumber,
  searchSupplier,
  sendMailToSupplier,
} from "../../../services/generalStore/purchaseorder/PurchaseOrderServices";
import {
  VerifyIcon,
  VerifyDisabledIcon,
} from "../../../../assets/CommonAssets";
import {
  DisableEditIcon,
  EditIcon,
  EmailDisableIcon,
  EmailEnableIcon,
} from "../../../../assets/CommonAssets";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import { addNewPurchaseOrderMultiple } from "../../../services/generalStore/pomultipleServices/POMultipleServices";
import { useLocation } from "react-router-dom";
import { UseCheckConsecutiveCharacters } from "../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";

const Verification = [
  {
    id: "All",
    value: "All",
    label: "All",
  },
  {
    id: "Pending",
    value: "Pending",
    label: "Pending",
  },
  {
    id: "Partial",
    value: "Partial",
    label: "Partial",
  },
  {
    id: "Completed",
    value: "Completed",
    label: "Completed",
  },
];

export default function POListModal(props) {
  let getUserInfo = JSON.parse(localStorage.getItem("userInfo"));
  const location = useLocation();

  const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "98%",
    height: "95%",
    overflowY: "scroll",
    bgcolor: "background.paper",
    border: "1px solid gray",
    boxShadow: 20,
    p: 2,
  };

  const defaultValues = {
    verification: "All",
    ammendmentpo: false,
    cancelledpo: false,
    searchPurchaseOrderNumber: null,
    storeName: "",
    supplierName: null,
    fromDate: new Date(),
    toDate: new Date(),
    searchItemCode: null,
  };

  const {
    control,
    reset,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
  });

  let getPurchaseOrderNumber = watch("searchPurchaseOrderNumber");
  let getSupplierName = watch("supplierName");
  let getSearchItemCode = watch("searchItemCode");
  let verification = watch("verification");
  let getAmmendmentPo = watch("ammendmentpo");
  let getCancelledPo = watch("cancelledpo");
  let getFromDate = watch("fromDate");
  let getToDate = watch("toDate");

  // useEffect(() => {
  //   props.setisCancelled(getCancelledPo);

  //   if (verification === "All") {
  //     props.setIsOrderPlaced(2);
  //   } else if (verification === "Completed") {
  //     props.setIsOrderPlaced(3);
  //   } else if (verification === "Pending") {
  //     props.setIsOrderPlaced(0);
  //   } else if (verification === "Partial") {
  //     props.setIsOrderPlaced(1);
  //   }
  // }, [getAmmendmentPo, getCancelledPo, verification]);

  const [poId, setPoId] = React.useState(null);

  const [poItemDataResult, setPOItemDataResult] = React.useState([]);
  const [supplier, setSupplier] = React.useState([]);
  const [poNumber, setPONumber] = React.useState([]);
  const [openPost, setOpenPost] = React.useState(false);
  const [openMailConfirmation, setOpenMailConfirmation] = React.useState(false);
  const [status, setStatus] = useState(null);
  const [selectRowData, setSelectedRowData] = React.useState(null);
  const [checkBoxIndex, setCheckBoxIndex] = React.useState(-1);
  const [openTransferPOItemConfirmation, setOpenTransferPOItemsConfirmation] =
    useState(false);
  const [privilege, setPrivilege] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [count, setCount] = useState();
  const [dataResult, setDataResult] = React.useState([]);
  const [itemOptions, setItemOptions] = useState([]);

  //get local storage data
  const getCashCounterData = JSON.parse(localStorage.getItem("userInfo"));
  console.log("local storage data", getCashCounterData);

  //send email confirmation
  const confirmationMsg = (
    <span>
      Send E-mail To{" "}
      <span className="font-bold">{selectRowData?.Supplier}</span>
    </span>
  );
  const handleClosePost = () => {
    if (openPost) {
      setOpenPost(false);
    }
  };

  const handleOpenmailConfiormation = () => {
    setOpenMailConfirmation(true);
  };
  const handleCloseEmailConfiormation = () => {
    if (openMailConfirmation) {
      setOpenMailConfirmation(false);
    }
  };

  const populatePOListTable = (forPagination) => {
    props?.setOpenBackdrop(true);
    let defaultParams = {
      fromDate: getFromDate,
      isAmmendment: false,
      isCancelled: getCancelledPo,
      isOrderPlaced:
        verification === "All"
          ? 2
          : verification === "Completed"
            ? 3
            : verification === "Pending"
              ? 0
              : verification === "Partial"
                ? 1
                : null,
      itemId: getSearchItemCode !== null ? getSearchItemCode?.id : 0,
      storeId: getUserInfo?.storeId,
      supplierId: getSupplierName?.id,
      toDate: getToDate,
      searchString: "",
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      menuId: location?.state?.menuId,
    };
    fetchAllPurchaseOrderList(defaultParams)
      .then((response) => {
        return response.data;
      })
      .then((res) => {
        props?.setOpenBackdrop(false);
        if (forPagination) {
          setDataResult((prevData) => [...prevData, ...res.result]);
        } else {
          setDataResult(res.result);
          setPage(0);
        }
        setCount(res.count);
      })
      .catch((error) => {
        errorAlert(error.message);
        props?.setOpenBackdrop(false);
      });
  };

  useMemo(() => {
    populatePOListTable();
  }, [
    getPurchaseOrderNumber,
    getSupplierName,
    getFromDate,
    getToDate,
    getCancelledPo,
    verification,
    getAmmendmentPo,
    getSearchItemCode,
  ]);

  console.log(
    "getFilterData",
    getPurchaseOrderNumber,
    getSupplierName,
    getFromDate,
    getToDate,
    getCancelledPo,
    verification,
    getAmmendmentPo,
  );

  //Searchable Supplier Api
  const handleSupplierChange = (autoSearchSupplier) => {
    if (autoSearchSupplier !== "") {
      searchSupplier(autoSearchSupplier)
        .then((response) => response.data)
        .then((res) => {
          setSupplier(res.result);
        });
    }
  };

  // Search PO Number Api
  const handlePoNumberChange = (searchString) => {
    if (searchString !== "") {
      searchPONumber(searchString)
        .then((response) => response.data)
        .then((res) => {
          setPONumber(res.result);
        });
    }
  };

  const handleItemChange = (autoSearchItemString) => {
    if (
      autoSearchItemString !== "" &&
      UseCheckConsecutiveCharacters(autoSearchItemString)
    ) {
      let obj = {
        deptStoreId: getUserInfo.storeId,
        itemCode: "%",
        itemName: "%",
        searchString: autoSearchItemString,
        supplierId: 0,
      };
      poItemDetailsSearch(obj)
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          setItemOptions(res.result);
        });
    }
  };

  React.useEffect(() => {
    setValue("storeName", props.getUserInfo.storeName);
  }, [props.getUserInfo]);

  const handleVerifyCancelPo = () => {
    if (poId !== null) {
      cancelVerifyPurchaseOrder(poId, status, props.menuId, props.privilege)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200) {
            successAlert(res.message);
            setPONumber(res.result);
            setOpenPost(false);
            populatePOListTable();
            setStatus(null);
          }
        })
        .catch((error) => {
          errorAlert(error.response.data.message || error.message);
        });
    }
  };
  console.log(
    "selectRowDataselectRowDataselectRowDataselectRowDataselectRowData",
    selectRowData,
  );

  //Single Select
  // const handleChange = (e, row, requiredIndex) => {
  //   let obj = {
  //     purchaseOrderIp: row.DOId,
  //     storeId: row.StoreId,
  //     supplierId: row.SupplierId,
  //   };

  //   setCheckBoxIndex(requiredIndex);

  //   if (e.target.checked === true) {
  //     fetchAllPurchaseOrderItemDetailList(obj)
  //       .then((response) => {
  //         return response.data;
  //       })
  //       .then((res) => {
  //         setPOItemDataResult(res.result);
  //       });
  //   }
  // };

  //prints
  const [urlforPrint, setUrlforPrint] = React.useState();
  const [openPrintModal, setOpenPrintModal] = React.useState(false);
  const handleClosePrintModal = () => {
    setOpenPrintModal(false);
  };
  const handleOpenPrintModal = (poId) => {
    fetchPrintPOForm(poId).then((response) => {
      setUrlforPrint(response);
      setOpenPrintModal(true);
    });
  };

  function sendEmail() {
    sendMailToSupplier(selectRowData?.DOId, getCashCounterData?.cashCounterId)
      .then((response) => response.data)
      .then((res) => {
        console.log("api  data is :", res);
        setOpenMailConfirmation(false);
        successAlert(res?.message);
      });
  }

  const handleEditPo = (row) => {
    console.log("The po to edit is :", row);
    let obj = {
      purchaseOrderIp: row.DOId,
      storeId: row.StoreId,
      supplierId: row.SupplierId,
    };

    let supplier = {
      id: row?.SupplierId,
      label: row?.Supplier,
      value: row?.SupplierId,
    };
    props?.setPoId(row?.DOId);

    fetchAllPurchaseOrderItemDetailList(obj)
      .then((response) => {
        return response.data;
      })
      .then((res) => {
        console.log("resresres321", res);
        // setPOItemDataResult(res?.result);
        if (res?.result?.length > 0) {
          let editData = [];

          for (let item of res?.result) {
            let modified = {
              searchItemCode: {
                id: item?.ItemId,
                label: item?.ItemName,
              },
              supplier: item?.Supplier,
              supplierId: item?.SupplierId,
              quantity: Number(item?.DOQty),
              uom: item?.UOM,
              rate: Number(item?.Rate),
              totalAmount: Number(item?.Amount),
              discPercentage: Number(item?.DiscPer),
              discAmount: Number(item?.DiscAmt),
              gstPercentage: Number(item?.VATPer),
              gstAmount: Number(item?.VATAmt),
              id: item?.DOId,
              netAmount: Number(item?.NetAmount),
              specification: item?.Specification,
              mrp: item?.MRP,
              doQty: Number(item?.DOQty),
              creditPeriod: "",
              expDeliveryDate: "",
              freeQty: 0,
              indentDetailsId: Number(item?.IndentDetailId),
              poDetailsId: item?.DODetailId,
              isOrderPlaced: true,
              itemId: item?.ItemId,
              itemManufacturedById: 0,
              markForClosed: false,
              pendQty: Number(item?.PendQty),
              vatAmt: Number(item?.VATAmt),
              vatPer: Number(item?.VATPer),
            };
            console.log("props?.from", props?.from);
            editData?.push(modified);

            if (props?.from === "poMultiple") {
              console.log("editDataeditDataeditData1", editData);
              props?.setSelectedPurchaseOrder(row);
              props?.setIsEditPo(true);
              props?.setPoMultipleData(editData);
              props?.handlePOListClose();
            } else if (props?.from === "PurchaseOrder") {
              console.log("editDataeditDataeditData2", editData);
              props?.setSelectedPurchaseOrder(row);
              props?.setPoData(editData);
              props?.setIsEditPo(true);
              props?.handlePOListClose();
            }
          }
        }
      });
  };

  console.log("poItemDataResult321", poItemDataResult);
  const handleSelectedRow = (row) => {
    if (row?.IsCancelled === false) {
      setPoId(row.DOId);
      fetchAllPurchaseOrderItemDetailList({
        purchaseOrderIp: row.DOId,
        storeId: row.StoreId,
        supplierId: row.SupplierId,
      })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          setPOItemDataResult(
            res.result?.map((val) => ({
              ...val,
              isChecked: false,
            })),
          );
        });
    }
  };

  const transferPOItemsList = () => {
    let postPOItemsList = [];
    for (let obj of poItemDataResult?.filter(
      (val) => val?.isChecked === true,
    )) {
      let POItemObj = {
        addedBy: props.getUserInfo.userId,
        amount: Number(Number(obj.Amount).toFixed(2)),
        creditPeriod: "",
        discAmt: Number(Number(obj?.DiscAmt).toFixed(2)),
        discPer: Number(obj?.DiscPer),
        doQty: Number(obj?.PendQty),
        expDeliveryDate: "1900-01-01T00:00:00.000Z",
        freeQty: 0,
        indentDetailsId: Number(obj?.IndentDetailId),
        isOrderPlaced: obj?.IsOrderPlaced,
        itemId: obj?.ItemId,
        itemManufacturedById: null,
        markForClosed: "",
        mrp: Number(obj?.MRP),
        netAmount: Number(Number(obj?.NetAmount).toFixed(2)),
        pendQty: "",
        rate: Number(obj?.Rate),
        specifications: obj?.Specification,
        storeId: props?.getUserInfo.storeId,
        supplierId: Number(obj?.SupplierId),
        vatAmt: Number(Number(obj?.VATAmt).toFixed(2)),
        vatPer: Number(obj?.VATPer),
        refPoId: poId,
      };
      postPOItemsList?.push(POItemObj);
    }
    addNewPurchaseOrderMultiple(
      location?.state?.menuId,
      privilege,
      postPOItemsList,
    )
      .then((response) => {
        if (response.data.statusCode === 200) {
          successAlert(response.data.message);
          setOpenTransferPOItemsConfirmation(false);
        }
      })
      .catch((error) => {
        errorAlert(error.response.data.message || error.message);
        setOpenTransferPOItemsConfirmation(false);
      });
  };

  //Table
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-3">
        <>
          <div className="flex pt-1 justify-center gap-2 cursor-pointer">
            {/* <>
              <Checkbox
                size="small"
                className="w-4 h-4 border border-gray-600 rounded"
                type="checkbox"
                color="primary"
                checked={checkBoxIndex === index ? true : false}
                value={index}
                onChange={(e) => {
                  handleChange(e, row, index);
                }}
                inputProps={{
                  "aria-label": "primary checkbox",
                }}
                name={`indentCheckBox${index}`}
              />
            </> */}
            {props?.userActions.map((actions, i) => (
              <>
                {actions.isAction === true ? (
                  <>
                    {actions.action === "Approve" ? (
                      <>
                        {row.IsCancelled === false && row.Verified === false ? (
                          <Tooltip title="Verify PO">
                            <button
                              type="button"
                              onClick={() => {
                                props.setPrivilege(actions.action);
                                setOpenPost(true);
                                setStatus(1);
                                setPoId(row.DOId);
                              }}
                            >
                              <VerifyIcon className="pl-3" />
                            </button>
                          </Tooltip>
                        ) : (
                          <VerifyDisabledIcon className="pl-3" />
                        )}
                      </>
                    ) : null}

                    {actions.action === "Cancel" ? (
                      <>
                        {row.IsCancelled === false && row.Verified === false ? (
                          <Tooltip title="Cancel PO">
                            <button
                              type="button"
                              className="text-black"
                              onClick={() => {
                                setPoId(row.DOId);
                                props.setPrivilege(actions.action);

                                setOpenPost(true);
                                setStatus(0);
                              }}
                            >
                              <HighlightOffIcon />
                            </button>
                          </Tooltip>
                        ) : (
                          <span className="text-gray-300">
                            <HighlightOffIcon />
                          </span>
                        )}
                      </>
                    ) : null}

                    {actions.action === "Print" ? (
                      <>
                        {row.IsCancelled === false ? (
                          <Tooltip title="Print PO">
                            <LocalPrintshopIcon
                              sx={{ color: "#4B5563" }}
                              onClick={() => {
                                handleOpenPrintModal(row.DOId);
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <LocalPrintshopIcon
                            sx={{ color: "#D7D7D7" }}
                            onClick={() => {
                              handleOpenPrintModal(row.DOId);
                            }}
                          />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                    {actions.action === "Edit" ? (
                      <>
                        {row.IsCancelled === false && row.Verified === false ? (
                          <Tooltip title="Edit PO">
                            <button
                              type="button"
                              onClick={() => {
                                handleEditPo(row);
                              }}
                              className={"h-6 px-[1px]"}
                            >
                              <EditIcon />
                            </button>
                          </Tooltip>
                        ) : (
                          <button type="button" disabled={true}>
                            <DisableEditIcon />
                          </button>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                    {actions.action === "Send Email" ? (
                      <>
                        {row.IsCancelled === false ? (
                          <Tooltip title="Send Email">
                            <button
                              type="button"
                              onClick={() => {
                                setOpenMailConfirmation(true);
                                setSelectedRowData(row);
                              }}
                              className={"h-6 px-[1px]"}
                            >
                              <EmailEnableIcon />
                            </button>
                          </Tooltip>
                        ) : (
                          <button type="button" disabled={true}>
                            <EmailDisableIcon />
                          </button>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                    {actions.action === "Close PO" && (
                      <>
                        {row?.IsCancelled === false ? (
                          <Tooltip title="Close PO">
                            <button
                              type="button"
                              onClick={() => {
                                setPoId(row.DOId);
                                props.setPrivilege(actions.action);
                                setOpenPost(true);
                                setStatus(2);
                              }}
                            >
                              <HighlightOffIcon />
                            </button>
                          </Tooltip>
                        ) : (
                          <span className="text-gray-300">
                            <HighlightOffIcon />
                          </span>
                        )}
                      </>
                    )}
                  </>
                ) : null}
              </>
            ))}
          </div>
        </>
      </div>
    );
  };

  const renderActionsPOItems = (row, index) => {
    return (
      <fieldset className="">
        <Checkbox
          size="small"
          checked={row?.isChecked}
          onChange={(e) => {
            let temp = [...poItemDataResult];
            temp[index].isChecked = e.target.checked;
            setPOItemDataResult(temp);
          }}
        />
      </fieldset>
    );
  };

  const renderInputPOItems = (row, index, header) => {
    setValue(`itemSupplier${index}`, {
      id: row?.SupplierId,
      value: row?.SupplierId,
      label: row?.Supplier,
    });
    setValue(`itemDoqty${index}`, row?.DOQty);
    return (
      <div className="my-1">
        {header === "Supplier" && (
          <div className="w-60 -mb-10 mt-1.5">
            <SearchDropdown
              control={control}
              name={`itemSupplier${index}`}
              handleInputChange={handleSupplierChange}
              dataArray={supplier}
              inputRef={{
                ...register(`itemSupplier${index}`, {
                  onChange: (e) => {
                    let temp = [...poItemDataResult];
                    temp[index].Supplier = e.target.value?.label;
                    temp[index].SupplierId = e.target.value?.id;
                    setPOItemDataResult(temp);
                  },
                }),
              }}
            />
          </div>
        )}
        {/* {header === "DOQty" && (
          <InputField
            control={control}
            name={`itemDoqty${index}`}
            inputRef={{
              ...register(`itemDoqty${index}`, {
                onChange: (e) => {
                  let temp = [...poItemDataResult];
                  temp[index].DOQty = Number(e.target.value);
                  setPOItemDataResult(temp);
                },
              }),
            }}
          />
        )} */}
      </div>
    );
  };

  return (
    <>
      <Modal
        open={props.poListModal}
        onClose={() => { }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle} className="space-y-2">
          <div className="flex justify-between items-center w-full">
            <div className="font-bold text-gray-800">Purchase Order List</div>
            <button type="button">
              <CancelPresentationIconButton
                onClick={() => {
                  props.handlePOListClose();
                  setPOItemDataResult([]);
                  setDataResult([]);
                  setPage(0);
                  reset(defaultValues);
                }}
              />
            </button>
          </div>
          <div className="">
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-x-2 gap-y-3">
              <div className="">
                <SearchDropdown
                  control={control}
                  name="searchPurchaseOrderNumber"
                  label="Search PO Number"
                  placeholder="Search PO Number"
                  searchIcon={true}
                  isSearchable={true}
                  isClearable={true}
                  dataArray={poNumber}
                  handleInputChange={handlePoNumberChange}
                />
              </div>
              <div className="w-full whitespace-nowrap">
                <InputField
                  name="storeName"
                  variant="outlined"
                  label="Store Name"
                  disabled={true}
                  error={errors.storeName}
                  control={control}
                />
              </div>
              <div className="">
                <SearchDropdown
                  control={control}
                  name="supplierName"
                  placeholder="Supplier Name"
                  error={errors.supplierName}
                  searchIcon={true}
                  isSearchable={true}
                  isClearable={true}
                  dataArray={supplier}
                  isMulti={false}
                  handleInputChange={handleSupplierChange}
                // inputRef={{
                //   ...register("supplierName", {
                //     onChange: (e) => {
                //       if (e.target.value !== null) {
                //         props.setPoListModalSupplierID(e.target.value.id);
                //       } else if (e.target.value === null) {
                //         props.setPoListModalSupplierID(0);
                //       }
                //     },
                //   }),
                // }}
                />
              </div>
              <div>
                <SearchDropdown
                  control={control}
                  searchIcon={true}
                  name="searchItemCode"
                  placeholder="Search Item Code"
                  isSearchable={true}
                  isClearable={true}
                  dataArray={itemOptions}
                  handleInputChange={handleItemChange}
                  error={errors.searchItemCode}
                />
              </div>

              <div className="flex gap-3">
                <DatePickerFieldNew
                  control={control}
                  name="fromDate"
                  label="From Date"
                  value={new Date()}
                  onChange={(newValue) => {
                    setValue("fromDate", newValue);
                  }}
                  disablePast={false}
                  disableFuture={true}
                  inputFormat="dd-MM-yyyy"
                />

                <DatePickerFieldNew
                  control={control}
                  name="toDate"
                  label="To Date"
                  value={new Date()}
                  onChange={(newValue) => {
                    setValue("toDate", newValue);
                  }}
                  disablePast={false}
                  disableFuture={true}
                  inputFormat="dd-MM-yyyy"
                />
              </div>
              <fieldset className="border border-gray-300 px-2 -mt-2">
                <legend className="px-1 text-xs font-semibold">Status</legend>
                <div className="-my-1">
                  <RadioField
                    label=""
                    name="verification"
                    control={control}
                    dataArray={Verification}
                  />
                </div>
              </fieldset>
              <div className="flex space-x-2 items-center">
                <CheckBoxField
                  control={control}
                  name="ammendmentpo"
                  label="Amendment PO's"
                />
                <CheckBoxField
                  control={control}
                  name="cancelledpo"
                  label="Cancelled PO's"
                />
              </div>
              <CommonButton
                type="button"
                className="border border-customRed text-customRed"
                label="Reset"
                onClick={() => {
                  reset(defaultValues);
                  setPOItemDataResult([]);
                }}
              />
            </div>

            <div className="w-full">
              {dataResult?.length > 0 ? (
                <CommonDynamicTablePaginationNew
                  dataResult={dataResult}
                  setDataResult={setDataResult}
                  populateTable={populatePOListTable}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  count={count}
                  renderActions={renderActions}
                  highlightRow={true}
                  handleSelectedRow={handleSelectedRow}
                  tableClass={"h-96"}
                  removeHeaders={[
                    "DOId",
                    "StoreId",
                    "SupplierId",
                    "IsOrderPlaced",
                  ]}
                  tableHeading={"Purchase Order List"}
                />
              ) : (
                ""
              )}
            </div>

            <div className="w-full">
              {poItemDataResult !== undefined && poItemDataResult.length > 0 ? (
                <>
                  <div className="flex justify-between items-center">
                    <span className="text-sm font font-semibold ">
                      Purchase Order Detail List
                    </span>
                    {props?.userActions?.map(
                      (action) =>
                        action.isAction === false &&
                        action?.action === "Transfer PO Items" && (
                          <CommonButton
                            type="button"
                            label="Transfer PO Items"
                            className="bg-customBlue text-white"
                            onClick={() => {
                              if (
                                poItemDataResult?.some(
                                  (val) => val?.isChecked === true,
                                )
                              ) {
                                setOpenTransferPOItemsConfirmation(true);
                                setPrivilege(action?.action);
                              } else {
                                warningAlert("Select items for transfer...!");
                              }
                            }}
                          />
                        ),
                    )}
                  </div>
                  <CommonDynamicTableNew
                    dataResult={poItemDataResult}
                    renderActions={renderActionsPOItems}
                    renderInput={renderInputPOItems}
                    editableColumns={["Supplier"]}
                    tableClass={"rounded h-64"}
                    removeHeaders={[
                      "ItemId",
                      "DOId",
                      "DODetailId",
                      "SupplierId",
                      "isChecked",
                      "IndentDetailId",
                    ]}
                    highlightRow={false}
                  />
                </>
              ) : (
                <h3 className="flex justify-center mt-12 mb-10 font-bold text-gray-600">
                  No Records Found...
                </h3>
              )}
            </div>
          </div>
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={handleClosePost}
        confirmationSubmitFunc={handleVerifyCancelPo}
        confirmationLabel="Confirmation"
        // status === 0 = "cancel" status === 1 "Verify"
        confirmationMsg={`Are you sure want to ${status === 0
          ? "Cancel"
          : status === 1
            ? "Verify"
            : status === 2
              ? "Close"
              : ""
          } this PO ?`}
        confirmationButtonMsg="Proceed"
      />
      <ConfirmationModal
        confirmationOpen={openMailConfirmation}
        confirmationHandleClose={handleCloseEmailConfiormation}
        confirmationSubmitFunc={sendEmail}
        confirmationLabel="Confirmation"
        // status === 0 = "cancel" status === 1 "Verify"
        confirmationMsg={confirmationMsg}
        confirmationButtonMsg="Send"
      />
      <ConfirmationModal
        confirmationOpen={openTransferPOItemConfirmation}
        confirmationHandleClose={() =>
          setOpenTransferPOItemsConfirmation(false)
        }
        confirmationSubmitFunc={transferPOItemsList}
        confirmationLabel="Confirmation"
        confirmationMsg={"Are you sure want to transfer PO Items ?"}
        confirmationButtonMsg="Confirm"
      />

      {/* Print Modal */}
      {openPrintModal ? (
        <CommonPrintModal
          open={openPrintModal}
          setOpen={setOpenPrintModal}
          handleOpen={handleOpenPrintModal}
          handleClose={handleClosePrintModal}
          urlforPrint={urlforPrint}
        />
      ) : null}
    </>
  );
}
